import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService, Core2Config} from '../../shared';
import {EntitySpendingLimitContainerModel} from '../../../../../../models/aggregates/erp/entity';

@Injectable({providedIn: 'root'})

export class EntitySpendingLimitService extends BaseApiTemplateService<EntitySpendingLimitContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX  +  Core2Config.ERP_PREFIX + 'entity-spending-limit-lines/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity-spending-limit-lines/backoffice-ep';
    this.httpClient = http;
  }
}
